<template>
    <div class="wecome-container">
        <div class="wecome_container_info">
            <div class="wecome_container_center">
                <div class="wecome_container_center_logo">
                    <img ref="gifImg" @load="gifLoadHandler" src="../assets/images/wecomeBig_start.gif"
                        class="wecome_container_center_logo_icon" :class="{ 'fade-out': isPlayEnd }" />
                    <img ref="staticImg" src="../assets/images/wecomeBig.gif"
                        class="wecome_container_center_logo_icon static-image" :class="{ 'fade-in': isPlayEnd }" />
                </div>
                <div class="wecome_container_center_info">
                    <!-- <div class="wecome_container_center_info_title">碳芯，首个双碳垂类大模型</div> -->
                    <div class="wecome_container_center_info_desc">为每一克碳排放发现更优解</div>
                </div>
                <!-- 输入框 -->
                <div class="item">
                    <div 
                        class="page_wecome_container_content" 
                        @click="handlerchat(2)"
                    >
                       <img class="welcome_btn_icon" src="../assets//images/welcome_btn_icon.png" alt=""> 碳知
                    </div>
                </div>

                <!-- <div class="wecome_container_bottom">
                   
                    <div @click="handlerchat(0)" class="wecome_container_bottom_view">
                        <div class="wecome_container_bottom_view_t">
                            <div class="wecome_container_bottom_view_t_icon">
                                <img src="../assets/images/chat_tpc.png" alt="" />
                            </div>
                            <div class="wecome_container_bottom_view_t_text">碳盘查</div>
                        </div>
                        <div class="wecome_container_bottom_view_b">智能统计企业全域温室气体数据</div>
                    </div>
                    
                    <div @click="handlerchat(1)" class="wecome_container_bottom_view">
                        <div class="wecome_container_bottom_view_t">
                            <div class="wecome_container_bottom_view_t_icon">
                                <img src="../assets/images/chat_tzj.png" alt="" />
                            </div>
                            <div class="wecome_container_bottom_view_t_text">碳足迹</div>
                        </div>
                        <div class="wecome_container_bottom_view_b">精准量化产品全生命周期碳排放</div>
                    </div>
                </div> -->
            </div>
        </div>
        <div class="wecome_bottom_police">
            <div class="row-1">
                <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank">{{ $t('footer.crf') }}</a>
                丨
                <a href="https://www.carbonneutrality-group.com/" target="_blank">{{ $t('footer.company') }}</a>
                丨
                <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">{{ $t('footer.icp') }}</a>
            </div>
            <div class="baseInfo m0">{{ $t('footer.vd') }} {{ version }}</div>
        </div>
        <el-dialog :title="$t('orderI18n.tips')" :visible.sync="tipsVisible" width="380px" :modal-append-to-body="false"
            :close-on-click-modal="false" custom-class="custom-delete-dialog"
            :before-close="() => (tipsVisible = false)" center top="30vh">
            <div class="dialog-content">
                <div class="dialog-text">{{ $t('bar.buyService') }}</div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="tipsVisible = false" class="custom-cancel-btn">
                    {{ $t('orderI18n.cancelBtn') }}
                </el-button>
                <el-button type="primary" @click="confirm" class="custom-delete-btn">
                    {{ $t('orderI18n.buy') }}
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex';
import { getAccount, } from "@/api";
import version from "@/utils/version";
export default {
    components: {

    },
    computed: {
        ...mapState(['customUiConfig', 'userInfo', 'accessType']),
        placeholder() {
            return this.$t('wecome.placeholder');
        },
        list() {
            return [
                this.$t('wecome.list[0]'),
                this.$t('wecome.list[1]'),
                this.$t('wecome.list[2]'),
                this.$t('wecome.list[3]'),
                this.$t('wecome.list[4]'),
                this.$t('wecome.list[5]')
            ];
        },
        isWecomePage() {
            return this.$route.name === 'WecomePage'; // 判断当前页面是否为 WecomePage
        },
    },
    data() {
        return {
            pendingToChat: null, // 记录未登录时的 toChat 参数
            timer: null,
            isPlayEnd: false, // 标记是否播放完毕
            version,
            tipsVisible: false,
            isShaking: false
        };
    },
    beforeDestroy() {
        clearTimeout(this.timer); // 销毁清除定时器，防泄漏
    },
    mounted() {
        // 重置播放标记并强制重新加载 GIF（添加时间戳避免缓存），以便每次刷新或在 SPA 路由返回时重新播放
        this.isPlayEnd = false;
        this.$nextTick(() => {
            const gif = this.$refs.gifImg;
            if (gif && gif.src) {
                const src = gif.src.split('?')[0];
                gif.src = src + '?t=' + Date.now();
            }
        });
    },
    methods: {
        ...mapMutations(['setUserInfo', 'setReadonly', 'setAccessType', 'setShowLogin', 'setSidebarExpanded', 'setPermission']),

        gifLoadHandler() {
            const frameDelay = 100;
            const totalFrames = 20;
            const totalPlayTime = frameDelay * totalFrames;
            this.timer = setTimeout(() => {
                this.isPlayEnd = true;
            }, totalPlayTime);
        },

        handleClick() {
            // tempReadonly
            this.setReadonly(false)
            this.isShaking = true
            setTimeout(() => {
                this.isShaking = false
                this.sendMessage()
            }, 200)
        },

        // 发送消息
        sendMessage(keepTrailingLineBreaks = true) {
            this.setAccessType('tz');
            this.$root.$emit('setSidebarActive', 'tz');
            this.$router.push({ name: 'ChatPage' });
        },

        // 模块点击事件
        handlerchat(i) {
            this.setReadonly(false)
            let value, title, index;
            if (i === 0) {
                value = 'tpc';
                title = '碳盘查项目';
                index = 0;
            } else if (i === 1) {
                value = 'tzj';
                title = '碳足迹项目';
                index = 1;
            } else {
                value = 'tz';
                title = '碳知';
                index = 2;
            }
            this.toChat(value, title, index);
        },

        // 碳盘查盘足迹事件
        async toChat(value, t, index) {
            console.log('首页页面')
            if (this.userInfo?.user_name) {
                // 已登录用户，正常流程
                const haveActive = await this.checkFeature(value);
                if (haveActive == undefined) {
                    return
                } else {
                    if (t && haveActive == false) {
                        console.log('首页')
                        this.setAccessType('tz');
                        this.setPermission(true)
                        this.$router.push({ name: 'ChatPage' });
                        return;
                    }
                    this.setAccessType(value);
                    if (!this.isWecomePage) {
                        // this.$emit('start-new-chat'); // 触发父组件事件
                    } else {
                        this.$router.push({ name: 'ChatPage' });
                    }
                }

            } else {
                // 未登录用户
                console.log('没有登录')
                this.setAccessType(value);
                // 直接访问时，显示登录框
                this.pendingToChat = { value, t, index };
                this.setShowLogin(true); // 显示登录框
            }
        },

        // 检查用户是否有访问某个功能的权限
        async checkFeature(t) {
            let features = "";
            if (this.userInfo?.user_name) {
                try {
                    const response = await getAccount({
                        user_id: this.userInfo?.user_id,
                    });
                    const { ...userInfo } = response.data.data;
                    features = userInfo?.features?.some(f => f.code === t);
                    this.setUserInfo(userInfo);
                    return features;
                }
                catch (error) {
                    this.$message.error(this.$t('accountI18n.getUserInfoError'));
                }
            }
        },

        // 显示产品介绍页面
        showProductIntroduction(value) {
            // 显示ThirdSide的产品介绍对话框
            if (this.$parent.$refs.dialogManager) {
                this.$parent.$refs.dialogManager.showProductIntroduction(value);
            } else {
                // 如果没有DialogManager，则使用原来的ServiceDialog
                this.$parent.$refs.serviceDialog.showModal();

                // 根据产品类型设置介绍内容
                if (value === 'tpc') {
                    // 碳盘查产品介绍
                    this.$parent.$refs.serviceDialog.selectProduct = '碳盘查';
                } else if (value === 'tzj') {
                    // 碳足迹产品介绍
                    this.$parent.$refs.serviceDialog.selectProduct = '碳足迹';
                }
            }
        },

        // 确认购买
        confirm() {
            this.tipsVisible = false; // 关闭提示框
            this.$parent.$refs.serviceDialog.showModal();
        },
    },
}
</script>
<style scoped>
.wecome-container {
    width: 100%;
    min-height: 100vh;
    background: url('../assets/images/welcome_back.png') no-repeat;
    background-size: 100% 100%;
    position: relative;
    overflow: overlay;
}

body,
html {
    margin: 0;
    padding: 0;
    height: 100%;
    overflow-y: overlay;
}

.wecome_container_info {
    width: 782px;
    height: calc(100vh - 336px);
    position: absolute;
    top: calc(100vh * 165 / 1080);
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.wecome_container_center {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.wecome_container_center_logo {
    width: 592px;
    height: 267px;
    position: relative;
}

.wecome_container_center_logo_icon {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
}

.static-image {
    opacity: 0;
}

.fade-out {
    opacity: 0;
}

.fade-in {
    opacity: 1;
}

.wecome_container_center_info {
    display: flex;
    flex-direction: column;
    height: auto;
    align-items: center;
}

.wecome_container_center_info_title {
    font-size: 60px;
    font-weight: 700;
    color: rgba(5, 32, 49, 1);
    font-family: 'Source Han Sans CN', sans-serif;
    line-height: 110px;
}

.wecome_container_center_info_desc {
    font-size: 48px;
    font-weight: 300;
    letter-spacing: 2px;
    color: rgba(5, 32, 49, 1);
    font-family: 'Source Han Sans CN', sans-serif;
    line-height: 110px;
    margin-bottom: calc(100vh * 37 / 1080);
}

@keyframes buttonBorderSpin {
  0% {
    --border-gradient-angle: 0turn;
  }

  100% {
    --border-gradient-angle: 1turn;
  }
}

@property --border-gradient-angle {
  syntax: "<angle>";
  inherits: true;
  initial-value: 0turn;
}

.item {
    background-image: conic-gradient(from var(--border-gradient-angle) at 50% 50%, transparent, rgba(88, 219, 255, 0.50) 3.48%, rgba(103, 174, 255, 0.75) 7.24%, #5E76FF 18%, transparent 30%);
    background-size: contain;
    padding: 1.5px; 
    animation: buttonBorderSpin 6s linear infinite 0ms;
    width: 156px;
    height: 76px;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    &:hover {
        background-image: none;
    }
}

.page_wecome_container_content {
    width: 152px;
    height: 72px;
    border-radius: 16px;
    padding: 12px 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-weight: 700;
    font-size: 32px;
    position: relative;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 6px 5.2px 0 rgba(176, 198, 213, 0.45);

}
.welcome_btn_icon{
    width: 32px;
    height: 32px;
    margin: 3px 5px 0 0;
}



/* 谷歌 */
::v-deep .el-input__inner::-webkit-input-placeholder {
    color: var(--global-placeholder);
    font-size: 16px;
    resize: none;
}

/* 火狐 */
::v-deep .el-input__inner:-moz-placeholder {
    color: var(--global-placeholder);
    font-size: 16px;
    resize: none;
}

/*ie*/
::v-deep .el-input__inner:-ms-input-placeholder {
    color: var(--global-placeholder);
    font-size: 16px;
    resize: none;
}

/* 网络安全文案 */
.wecome_bottom_police {
    width: 470;
    height: 30;
    position: absolute;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
    gap: 10px;
    opacity: 1;
    font-weight: 400px;
    color: rgba(170, 179, 187, 1);
}

.row-1 {
    display: flex;
    justify-content: center;
    align-items: center;
}

.wecome_bottom_police a {
    color: rgba(170, 179, 187, 1);
    text-decoration: none;
}
</style>